import { render, staticRenderFns } from "./ExchangePreview.vue?vue&type=template&id=612fe6e8&scoped=true"
import script from "./ExchangePreview.vue?vue&type=script&lang=js"
export * from "./ExchangePreview.vue?vue&type=script&lang=js"
import style0 from "./ExchangePreview.vue?vue&type=style&index=0&id=612fe6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612fe6e8",
  null
  
)

export default component.exports